import React from "react";
import T from "prop-types";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";
import { print } from "MODULES/inventories/actions";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { DataTable } from "MODULES/shared/components";
import _ from "lodash";
import { Field } from "redux-form";
import { FormInput } from "MODULES/shared/components/Forms/FormInput/FormInput";
import { properCase } from "LIB/formatters/text";
import { COMPANY_NAME, ID, NOTES } from "APP_ROOT/constants";
import { INVENTORY } from "MODULES/inventories/constants";

function Form({ inventory, ...props }) {
  const OBTAINED_FROM = "obtained_from";

  const onObtainedFromOther = event => {
    const value = event.target.value;

    props.change(OBTAINED_FROM, value);
  };

  const radioSelect = item => (
    <input
      type="radio"
      name={OBTAINED_FROM}
      className="radio-inline"
      checked={props.getFieldValue(OBTAINED_FROM) === item.code}
      onChange={() => props.change(OBTAINED_FROM, item.code)}
    />
  );

  const renderPORow = item => (
    <tr key={`po-${item.id}`}>
      <td />
      <td className="text-center">
        {radioSelect(item, "purchase_order_line_item")}
      </td>
      <td>{_.get(item, "code")}</td>
      <td />
    </tr>
  );

  const renderSORow = item => (
    <tr key={`so-${item.id}`}>
      <td />
      <td className="text-center">
        {radioSelect(item, "sales_order_line_item")}
      </td>
      <td>{item.code}</td>
      <td />
    </tr>
  );

  const renderRORow = item => (
    <tr key={`ro-${item.id}`}>
      <td />
      <td className="text-center">
        {radioSelect(item, "repair_order_line_item")}
      </td>
      <td>{item.code}</td>
      <td />
    </tr>
  );

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={12}>
            <DataTable>
              <DataTable.Head>
                <th />
                <th />
                <th>Code</th>
              </DataTable.Head>
              <DataTable.Body>
                {[inventory.most_recent_purchase_order]
                  .filter(r => r)
                  .map(renderPORow)
                  .concat(
                    [inventory.most_recent_sales_order]
                      .filter(r => r)
                      .map(renderSORow)
                  )
                  .concat(
                    [inventory.most_recent_repair_order]
                      .filter(r => r)
                      .map(renderRORow)
                  )}
                <tr>
                  <td />
                  <td className="text-center" />
                  <td>Other</td>
                  <td>
                    <Field
                      component={FormInput}
                      name={OBTAINED_FROM}
                      className="form-control"
                      onChange={onObtainedFromOther}
                    />
                  </td>
                </tr>
              </DataTable.Body>
            </DataTable>
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <div className="form-group">
              <CheckGroup title="Include Company Name In Label">
                <Field
                  name="include_company_name"
                  component={Check}
                  label={properCase(COMPANY_NAME)}
                />
              </CheckGroup>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <CheckGroup title="Include Inventory Notes">
                <Field
                  name={NOTES}
                  component={Check}
                  label={properCase(NOTES)}
                />
              </CheckGroup>
            </div>
          </Col>
        </FormRow>
        <FormRow>
          <hr className="hr-xs hr-dashed" />
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  inventory: T.shape({})
};

export default connect(
  () => ({
    initialValues: {
      include_company_name: true,
      notes: true
    }
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(print(data, _.get(ownProps, [INVENTORY, ID].join("."))))
  })
)(
  form({
    form: "printInventoryForm"
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/Print/Form.jsx